import { Button } from '@mui/material';
import * as React from 'react'
import Loader from "react-loader-spinner";
import { TerminalScoreContext } from './TerminalScoreProvider';



type Props = {
  children
}

const TerminalScoreLoadingGuard: React.FC = ({ children }: Props) => {
  const scoreData = React.useContext(TerminalScoreContext);

  const isLoading = !scoreData.terminalScore;
  const hasError = scoreData.hasError;

  return (
    <div>
      {hasError &&
        <div className="flex flex-col items-center my-20">
          <p className="font-medium mb-2">Network error</p>
        </div>
      }
      {!hasError && isLoading &&
        <div className="flex flex-col items-center my-20">
          <Loader color="#27A3A4" type="ThreeDots"></Loader>
          <p className="">Loading the Terminal Score...</p>
          <p className="text-xs text-gray-700">This can take several seconds. Just hang on tight.</p>
        </div>
      }
      {!isLoading && children}
    </div>
  );
}

export default TerminalScoreLoadingGuard;

